import styled from 'styled-components';

const FieldWrap = styled.div`
  width: 100%;

  > * {
    margin-bottom: 1rem;
  }
`;

export default FieldWrap;


// WEBPACK FOOTER //
// ./src/modules/common/components/form/FieldWrap.js